// AUTO-GENERATED FILE. Do not edit manually.
// Run `npm run env:sync` after changing .env.

export const environment = {
  production: false,
  authUrl: 'https://auth.dev.sistemadyg.com.mx',
  authApiUrl: 'https://api.auth.dev.sistemadyg.com.mx',
  authApiVersion: 'v1',
  settingsApiUrl: 'https://api.settings.dev.sistemadyg.com.mx',
  crmApiUrl: 'https://api.crm.dev.sistemadyg.com.mx',
  erpApiUrl: 'https://api.erp.dev.sistemadyg.com.mx',
  authVerificationApiUrl: 'https://api.verification.dev.sistemadyg.com.mx/api',
  authVerificationApiVersion: 'v_1',
  authVerificationGuestSecret: '462D4A614E645261176B586E3272357538782F413F4428472B4B6250655368566D5900YBX33676397924422645294840KO635166546A576E5A7234753777217A',
  verificationApiUrl: 'https://api.verification.dev.sistemadyg.com.mx/api',
  verificationApiVersion: 'v1',
  demoApiUrl: 'https://demo-api.dev.sistemadyg.com.mx',
  demoFeaturesEnabled: true,
  demoAdminEnabled: true,
  recaptchaSiteKey: '6LfG0oItAAAAAFsoijkr4UhVn9KgKIMqmbCiqVbW',
  systems: {
    crm:   'https://crm.dev.sistemadyg.com.mx',
    erp:   'https://erp.dev.sistemadyg.com.mx/dashboard/treasury',
    bi:    'https://bi.dev.sistemadyg.com.mx',
    admin: 'https://admin.dev.sistemadyg.com.mx/companies/dashboard',
  },
} as const;
